<template>
    <div class="select-modal aba-geral">
        <alert-container :messages="msgs" />

        <!-- Botão de Salvar -->
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="verifyPermissions(produtoIntegracao)"
                    @click="save"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t("salvar") }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <!-- Dados inicias do produto -->
        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">

                <!-- Código -->
                <div class="column is-3">
                    <v-input
                        :id="generateId(1)"
                        ref="codigoInput"
                        v-model="produto.idprodutoerp"
                        placeholder="placeholder-preencha"
                        :maxlength="50"
                        title="codigo"
                        msg="msg-campo-obrigatorio"
                        :invalid="isNull(produto.idprodutoerp)"
                        required
                        :disabled="isUpdate || produtoIntegracao"
                        tooltipLabel="informacao-codigo-produto"
                        tooltipSize="is-small"
                    />
                </div>
                <!-- Fim Código -->

                <!-- Descrição -->
                <div class="column is-6">
                    <v-input
                        :id="generateId(2)"
                        ref="descricaoInput"
                        v-model="produto.descricao"
                        placeholder="placeholder-preencha"
                        :maxlength="150"
                        title="descricao"
                        msg="msg-campo-obrigatorio"
                        :invalid="isNull(produto.descricao)"
                        required
                        tooltipLabel="descricao-produto"
                        tooltipSize="is-small"
                        :disabled="cantEdit || produtoIntegracao"
                    />
                </div>
                <!-- Fim Descrição -->

                <!-- Oculta produto -->
                <div class="column is-3">
                    <vss-select
                        :id="generateId(3)"
                        ref="ocultaProdutoSelect"
                        title="oculta-produto"
                        :searchable="false"
                        :options="ocultaProdutoSelect"
                        v-model="produto.oculta"
                        class="no-clear"
                        tooltipLabel="informacao-oculta-produto"
                        tooltipPosition="is-left"
                        :disabled="cantEdit || produtoIntegracao"
                        @onBlurFunction="sendIsChanged()"
                        mlLabels
                    />
                </div>
                <!-- Fim Oculta produto -->

                <!-- Grupo -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <vss-select
                                :id="generateId(4)"
                                ref="grupoSelect"
                                title="grupo"
                                :disableMLtitle="false"
                                :clearable="false"
                                searchable
                                :options="grupoSelect"
                                v-model="grupoSelected"
                                :mlLabels="false"
                                tooltipLabel="grupoproduto"
                                tooltipSize="is-small"
                                :disabled="
                                    cantEdit || produtoIntegracao
                                "
                                @onBlurFunction="sendIsChanged()"
                                @search="
                                    (event) => loadGrupo(event, true)
                                "
                                @input="() => loadSubGrupo('.*')"
                                :loading="grupoLoading"
                            />
                        </div>
                        <div
                            v-if="verifyPermissions(grupoIntegracao)"
                            class="
                                control
                                padding-label padding-label-custom
                            "
                        >
                            <b-button
                                @click="showModal('grupo')"
                                icon-right="plus"
                                :disabled="cantEdit || produtoIntegracao"
                                v-tippy 
                                :title="$t('adicionar') + ' ' + $t('grupo')"
                            />
                        </div>
                    </div>
                </div>
                <!-- Fim Grupo -->

                <!-- Sub grupo -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <vss-select
                                :id="generateId(5)"
                                ref="subGrupoSelect"
                                title="subgrupo"
                                :disableMLtitle="false"
                                :clearable="false"
                                searchable
                                :options="subGrupoSelect"
                                v-model="subGrupoSelected"
                                :mlLabels="false"
                                tooltipLabel="subgrupoproduto"
                                tooltipSize="is-small"
                                :disabled="
                                    cantEdit || produtoIntegracao
                                "
                                @onBlurFunction="sendIsChanged()"
                                @search="
                                    (event) => loadSubGrupo(event, true)
                                "
                                @input="() => loadLinha('.*')"
                                :loading="subGrupoLoading"
                            />
                        </div>
                        <div
                            v-if="verifyPermissions(subGrupoIntegracao)"
                            class="
                                controlpadding-label
                                padding-label-custom
                            "
                        >
                            <b-button
                                @click="showModal('subgrupo')"
                                icon-right="plus"
                                :disabled="cantEdit || produtoIntegracao"
                                v-tippy 
                                :title="$t('adicionar') + ' ' + $t('subgrupo')"
                            />
                        </div>
                    </div>
                </div>
                <!-- Sub grupo -->

                <!-- Linha -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <vss-select
                                :id="generateId(6)"
                                ref="linhaSelect"
                                title="linha"
                                :disableMLtitle="false"
                                :clearable="false"
                                searchable
                                :options="linhaSelect"
                                v-model="linhaSelected"
                                :mlLabels="false"
                                tooltipLabel="linhaproduto"
                                tooltipSize="is-small"
                                tooltipPosition="is-left"
                                :disabled="
                                    cantEdit || produtoIntegracao
                                "
                                @onBlurFunction="sendIsChanged()"
                                @search="loadLinha($event, true)"
                                :loading="linhaLoading"
                            />
                        </div>
                        <div
                            v-if="verifyPermissions(linhaIntegracao)"
                            class="
                                control
                                padding-label padding-label-custom
                            "
                        >
                            <b-button
                                @click="showModal('linha')"
                                icon-right="plus"
                                :disabled="cantEdit || produtoIntegracao"
                                v-tippy
                                :title="$t('adicionar') + ' ' + $t('linha')"
                            />
                        </div>
                    </div>
                </div>
                <!-- Fim Linha -->

                <!-- Categoria -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <vss-select
                                :id="generateId(7)"
                                ref="categoriaSelect"
                                title="categoria"
                                :disableMLtitle="false"
                                :clearable="false"
                                searchable
                                :options="categoriaSelect"
                                v-model="categoriaSelected"
                                :mlLabels="false"
                                tooltipLabel="informacao-categoria-produto"
                                tooltipSize="is-small"
                                :disabled="
                                    cantEdit || produtoIntegracao
                                "
                                @onBlurFunction="sendIsChanged()"
                                @search="loadCategoria"
                                :loading="categoriaLoading"
                            />
                        </div>
                        <div
                            v-if="verifyPermissions(categoriaIntegracao)"
                            class="
                                control
                                padding-label padding-label-custom
                            "
                        >
                            <b-button
                                @click="showModal('categoria')"
                                icon-right="plus"
                                :disabled="cantEdit || produtoIntegracao"
                                v-tippy 
                                :title="$t('adicionar') + ' ' + $t('categoria')"
                            />
                        </div>
                    </div>
                </div>
                <!-- Fim Categoria -->

                <!-- Ramo -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <vss-select
                                :id="generateId(8)"
                                ref="ramoSelect"
                                title="ramo"
                                :disableMLtitle="false"
                                :clearable="false"
                                searchable
                                :options="ramoSelect"
                                v-model="ramoSelected"
                                :mlLabels="false"
                                tooltipLabel="ramo-produto"
                                tooltipSize="is-small"
                                :disabled="
                                    cantEdit || produtoIntegracao
                                "
                                @onBlurFunction="sendIsChanged()"
                                @search="loadRamo"
                                :loading="ramoLoading"
                            />
                        </div>
                        <div
                            v-if="verifyPermissions(ramoIntegracao)"
                            class="
                                control
                                padding-label padding-label-custom
                            "
                        >
                            <b-button
                                @click="showModal('ramo')"
                                icon-right="plus"
                                :disabled="cantEdit || produtoIntegracao"
                                v-tippy 
                                :title="$t('adicionar') + ' ' + $t('ramo')"
                            />
                        </div>
                    </div>
                </div>
                <!-- Fim Ramo -->

                <!-- Cliente unico para produto -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <vss-select
                                :id="generateId(9)"
                                ref="clienteSelect"
                                title="cliente-unico-produto"
                                :disableMLtitle="false"
                                :clearable="false"
                                searchable
                                :options="clienteSelect"
                                v-model="clienteSelected"
                                :mlLabels="false"
                                tooltipLabel="informacao-cliente-produto"
                                tooltipSize="is-small"
                                tooltipPosition="is-left"
                                :disabled="
                                    cantEdit || produtoIntegracao
                                "
                                @onBlurFunction="sendIsChanged()"
                                @search="(event) => loadCliente(event, true)"
                                :loading="clienteLoading"
                            />
                        </div>
                        <div
                            v-if="verifyPermissions(clienteIntegracao)"
                            class="
                                control
                                padding-label padding-label-custom
                            "
                        >
                            <b-button
                                @click="redirectCadastroCliente"
                                icon-right="plus"
                                :disabled="cantEdit || produtoIntegracao"
                                v-tippy 
                                :title="$t('adicionar') + ' ' + $t('cliente')"
                            />
                        </div>
                    </div>
                </div>
                <!-- Fim Cliente unico para produto -->

                <!-- Família -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <vss-select
                                :id="generateId(10)"
                                ref="familiaSelect"
                                title="familia"
                                :disableMLtitle="false"
                                :clearable="false"
                                searchable
                                :options="familiaSelect"
                                v-model="familiaSelected"
                                :mlLabels="false"
                                tooltipLabel="informacao-familia-produto"
                                tooltipSize="is-small"
                                :disabled="
                                    cantEdit || produtoIntegracao
                                "
                                @onBlurFunction="sendIsChanged()"
                                @search="loadFamilia"
                                :loading="familiaLoading"
                            />
                        </div>
                        <div
                            v-if="verifyPermissions(familiaIntegracao)"
                            class="
                                control
                                padding-label padding-label-custom
                            "
                        >
                            <b-button
                                @click="showModal('familia')"
                                icon-right="plus"
                                :disabled="cantEdit || produtoIntegracao"
                                v-tippy 
                                :title="$t('adicionar') + ' ' + $t('familia')"
                            />
                        </div>
                    </div>
                </div>
                <!-- Fim Família -->

                <!-- Unidade de medida -->
                <div v-if="isUpdate" class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <vss-select
                                :id="generateId(11)"
                                ref="unidadeMedidaSelect"
                                title="unidade-medida"
                                :disableMLtitle="false"
                                :clearable="false"
                                searchable
                                :options="unidadeMedidaSelect"
                                v-model="unidadeMedidaSelected"
                                :mlLabels="false"
                                tooltipLabel="informacao-select-unidade-medida-produto"
                                tooltipSize="is-small"
                                :disabled="
                                    cantEdit || produtoIntegracao
                                "
                                @onBlurFunction="sendIsChanged()"
                                @search="loadUnidadeMedida"
                                :loading="unidadeMedidaLoading"
                            />
                        </div>
                        <div
                            v-if="verifyPermissions(unidadeMedidaIntegracao)"
                            class="
                                control
                                padding-label padding-label-custom
                            "
                        >
                            <b-button
                                @click="showModal('unidade-medida')"
                                icon-right="plus"
                                :disabled="cantEdit || produtoIntegracao"
                                v-tippy 
                                :title="$t('adicionar') + ' ' + $t('unidade-medida')"
                            />
                        </div>
                    </div>
                </div>
                <!-- Fim Unidade de medida -->

                <!-- Unidade de medida do produto -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <v-input
                        :id="generateId(12)"
                        ref="unidadeMedidaInput"
                        v-model="produto.undmedida"
                        placeholder="placeholder-preencha"
                        :maxlength="100"
                        title="unidademedida-produto"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="informacao-unidade-medida-produto"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                        :disabled="cantEdit || produtoIntegracao"
                    />
                </div>
                <!-- Fim Unidade de medida do produto -->

                <!-- Descrição embalagem -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <v-input
                        :id="generateId(13)"
                        ref="descricaoEmbalagemInput"
                        v-model="produto.embalagem"
                        placeholder="placeholder-preencha"
                        :maxlength="100"
                        title="descricao-embalagem"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="embalagem-produto"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                        :disabled="cantEdit || produtoIntegracao"
                    />
                </div>
                <!-- Fim Descrição embalagem -->

                <!-- Descrição marca -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <v-input
                        :id="generateId(14)"
                        ref="descricaoMarcaInput"
                        v-model="produto.marca"
                        placeholder="placeholder-preencha"
                        :maxlength="50"
                        title="descricao-marca"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="produto-marca"
                        tooltipSize="is-small"
                        :disabled="cantEdit || produtoIntegracao"
                    />
                </div>
                <!-- Fim Descrição marca -->

                <!-- Código de barras -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <v-input
                        :id="generateId(15)"
                        ref="codigoBarrasInput"
                        v-model="produto.codbarras"
                        placeholder="placeholder-preencha"
                        :maxlength="70"
                        title="codigo-barra"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="codbarras-produto"
                        tooltipSize="is-small"
                        :disabled="cantEdit || produtoIntegracao"
                        validchars="0123456789"
                    />
                </div>
                <!-- Fim Código de barras -->

                <!-- Quantidade de itens em uma caixa -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <v-input
                        :id="generateId(16)"
                        ref="qtdItensCaixaInput"
                        v-model="produto.undcaixa"
                        placeholder="placeholder-preencha"
                        :maxlength="10"
                        title="qtde-itens-caixa"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="qtd-itens-caixa-produto"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                        :disabled="cantEdit || produtoIntegracao"
                        validchars="0123456789."
                    />
                </div>
                <!-- Fim Quantidade de itens em uma caixa -->

                <!-- codigo MAPA -->
                <div class="column is-4">
                    <v-input
                        :id="generateId(17)"
                        ref="codigoMapaInput"
                        v-model="codigo_mapa"
                        :maxlength="255"
                        :title="$t('codigomapa')"
                        tooltipLabel="codigo-mapa"
                        tooltipSize="is-small"
                        :disabled="cantEdit || produtoIntegracao"
                        :uppercase="false"
                    />
                </div>
                <div class="column is-4">
                    <vss-select
                        :id="generateId(18)"
                        ref="emiteReceitaSelect"
                        title="emite-receita"
                        :searchable="false"
                        :options="emiteReceitaSelect"
                        v-model="emiteReceitaSelected"
                        class="no-clear"
                        tooltipLabel="informacao-emite-receita"
                        tooltipPosition="is-left"
                        :disabled="cantEdit || produtoIntegracao"
                        @onBlurFunction="sendIsChanged()"
                        mlLabels
                    />
                </div>
                <!-- Fim codigo MAPA -->
            </div>
        </div>
        <!-- Fim dos dados inicias do produto -->

        <!-- Segundo formulário -->
        <div class="page-container form-columns-fit mt-4 mb-4">
            <div class="columns is-flex-wrap">
                <!-- NCM -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <v-input
                        :id="generateId(19)"
                        ref="ncmInput"
                        v-model="produto.ncm"
                        placeholder="placeholder-preencha"
                        :maxlength="10"
                        title="ncm-produto"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="informacao-ncm-produto"
                        tooltipSize="is-small"
                        :disabled="cantEdit || produtoIntegracao"
                        validchars="0123456789."
                    />
                </div>
                <!-- Fim NCM -->

                <!-- CST -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <v-input
                        :id="generateId(20)"
                        ref="cstInput"
                        v-model="produto.cst"
                        placeholder="placeholder-preencha"
                        :maxlength="10"
                        title="cst-produto"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="informacao-cst-produto"
                        tooltipSize="is-small"
                        :disabled="cantEdit || produtoIntegracao"
                        validchars="0123456789"
                    />
                </div>
                <!-- Fim CST -->

                <!-- CEST -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <v-input
                        :id="generateId(21)"
                        ref="cestInput"
                        v-model="produto.cest"
                        placeholder="placeholder-preencha"
                        :maxlength="10"
                        title="cest-produto"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="informacao-cest-produto"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                        :disabled="cantEdit || produtoIntegracao"
                        validchars="0123456789."
                    />
                </div>
                <!-- Fim CEST -->

                <!-- IPI -->
                <div class="column is-4">
                    <v-input
                        :id="generateId(22)"
                        ref="ipiInput"
                        v-model="produto.ipi"
                        placeholder="placeholder-preencha"
                        title="ipi-produto"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="informacao-ipi-produto"
                        tooltipSize="is-small"
                        :disabled="cantEdit || produtoIntegracao"
                        validchars="0123456789."
                        :maxlength="13"
                    />
                </div>
                <!-- Fim IPI -->

                <!-- Porcentagem troca -->
                <div class="column is-4">
                    <v-input
                        :id="generateId(23)"
                        ref="porcentagemTrocaInput"
                        v-model="produto.porctroca"
                        placeholder="placeholder-preencha"
                        title="porctroca-produto"
                        :invalid="validatePorcentagemInner()"
                        maxLength="5"
                        tooltipLabel="informacao-porcentagem-troca-produto"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                        :disabled="cantEdit || produtoIntegracao"
                        validchars="0123456789."
                        porcentagem
                        icon="percent"
                        :msg="showMessage()"
                    />
                </div>
                <!-- Fim Porcentagem troca -->

                <div class="column is-4">
                    <v-input
                        :id="generateId(32)"
                        ref="prazoMedioCompraInput"
                        v-model="produto.prazoMedioCompra"
                        placeholder="placeholder-preencha"
                        :maxlength="10"
                        title="prazo-medio-compra-produto"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="tooltip-prazo-medio-compra"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                        :disabled="cantEdit || produtoIntegracao"
                        validchars="0123456789."
                    />
                </div>
            </div>
        </div>
        <!-- Fim do segundo formulário -->

        <!-- Terceiro formulário -->
        <div class="page-container form-columns-fit mt-4 mb-4">
            <div class="columns is-flex-wrap">
                <!-- Espessura -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <v-input
                        :id="generateId(24)"
                        ref="espressuraInput"
                        v-model="produto.espessura"
                        placeholder="placeholder-preencha"
                        title="espessura-produto"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="informacao-caracteristica-produto"
                        tooltipSize="is-small"
                        :disabled="cantEdit || produtoIntegracao"
                        validchars="0123456789."
                        :maxlength="13"
                        useMask
                        :vMask="['##########.##']"
                    />
                </div>
                <!-- Fim Espessura -->

                <!-- Comprimento -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <v-input
                        :id="generateId(25)"
                        ref="comprimentoInput"
                        v-model="produto.comprimento"
                        placeholder="placeholder-preencha"
                        title="comprimento-produto"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="informacao-caracteristica-produto"
                        tooltipSize="is-small"
                        :disabled="cantEdit || produtoIntegracao"
                        validchars="0123456789."
                        :maxlength="13"
                        useMask
                        :vMask="['##########.##']"
                    />
                </div>
                <!-- Fim Comprimento -->

                <!-- Largura -->
                <div class="column is-12-mobile is-6-tablet is-6-desktop is-4-widescreen">
                    <v-input
                        :id="generateId(26)"
                        ref="larguraInput"
                        v-model="produto.largura"
                        placeholder="placeholder-preencha"
                        title="largura-produto"
                        tooltipLabel="informacao-caracteristica-produto"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                        :disabled="cantEdit || produtoIntegracao"
                        validchars="0123456789."
                        :maxlength="13"
                        useMask
                        :vMask="['##########.##']"
                    />
                </div>
                <!-- Fim Largura -->

                <!-- Peso -->
                <div class="column is-6">
                    <v-input
                        :id="generateId(27)"
                        ref="pesoInput"
                        v-model="produto.peso"
                        placeholder="placeholder-preencha"
                        title="peso-do-produto"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="informacao-peso-produto"
                        tooltipSize="is-small"
                        :disabled="cantEdit || produtoIntegracao"
                        validchars="0123456789."
                    />
                </div>
                <!-- Fim Peso -->

                <!-- Cubagem -->
                <div class="column is-6">
                    <v-input
                        :id="generateId(28)"
                        ref="cubagemInput"
                        v-model="produto.cubagem"
                        placeholder="placeholder-preencha"
                        title="cubagem"
                        msg="msg-campo-obrigatorio"
                        tooltipLabel="informacao-cubagem-produto"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                        :disabled="cantEdit || produtoIntegracao"
                        validchars="0123456789."
                    />
                </div>
                <!-- Fim Cubagem -->
            </div>
        </div>
        <!-- Fim do terceiro formulário -->

        <!-- Quarto formulário -->
        <div class="page-container form-columns-fit mt-4 mb-4">
            <div class="columns is-flex-wrap">
                <!-- Observação Geral -->
                <div class="column is-6">
                    <v-textarea
                        ref="obsFinanceiraInput"
                        :id="generateId(29)"
                        v-model="produto.observacaogeral"
                        title="observacaogeral-produto"
                        :disableMLtitle="false"
                        placeholder="placeholder-preencha"
                        :rows="5"
                        :maxRows="5"
                        :disableTransform="true"
                        tooltipLabel="informacao-obsgeral-produto"
                        tooltipSize="is-small"
                        :disabled="cantEdit || produtoIntegracao"
                        :validchars="''"
                        :maxlength="500"
                    />
                </div>
                <!-- Observação Geral -->

                <!-- Complemento -->
                <div class="column is-6">
                    <v-textarea
                        ref="complementoInput"
                        :id="generateId(30)"
                        v-model="produto.complemento"
                        title="complemento-produto"
                        :disableMLtitle="false"
                        placeholder="placeholder-preencha"
                        :rows="5"
                        :maxRows="5"
                        :disableTransform="true"
                        tooltipLabel="informacao-complemento-produto"
                        tooltipSize="is-small"
                        tooltipPosition="is-left"
                        :disabled="cantEdit || produtoIntegracao"
                        :validchars="''"
                        :maxlength="255"
                    />
                </div>
                <!-- Fim Complemento -->

                <!-- Referência -->
                <div class="column is-12">
                    <v-textarea
                        ref="referenciaInput"
                        :id="generateId(31)"
                        v-model="produto.referencia"
                        :title="'referencia-produto'"
                        :disableMLtitle="false"
                        placeholder="placeholder-preencha"
                        :rows="5"
                        :maxRows="5"
                        :disableTransform="true"
                        tooltipLabel="informacao-referencia-produto"
                        tooltipSize="is-small"
                        :disabled="cantEdit || produtoIntegracao"
                        :validchars="''"
                        :maxlength="100"
                    />
                </div>
                <!-- Fim Referência -->
            </div>
        </div>
        <!-- Fim Quarto formulário -->

        <!-- MODAIS -->
        <b-modal :active.sync="buttonPlusIsClicked">
            <GrupoProdutoModal
                @sucesso="updateSelects"
                @voltar="closeModal"
                v-if="modalSelect === 'grupo'"
            />
            
            <SubGrupoProdutoModal
                @sucesso="updateSelects"
                @voltar="closeModal"
                v-if="modalSelect === 'subgrupo'"
                :grupo="grupoSelected"
            />

            <LinhaProdutoModal
                @sucesso="updateSelects"
                @voltar="closeModal"
                v-if="modalSelect === 'linha'"
                :grupo="grupoSelected"
                :subgrupo="subGrupoSelected"
            />

            <CategoriaModal
                @sucesso="updateSelects"
                @voltar="closeModal"
                v-if="modalSelect === 'categoria'"
            />

            <RamoModal
                @sucesso="updateSelects"
                @voltar="closeModal"
                v-if="modalSelect === 'ramo'"
            />

            <ProdutoFamiliaModal
                @sucesso="updateSelects"
                @voltar="closeModal"
                v-if="modalSelect === 'familia'"
            />
            
            <UnidadeMedidaCadastroModal
                @sucesso="updateSelects"
                @fecharModal="closeModal"
                :autovinculo="true"
                :idproduto="produto.idproduto"
                v-if="modalSelect === 'unidade-medida'"
            />
        </b-modal>
    </div>
</template>

<script>
// Services
import ProdutoService from "@/services/vendas/produto/ProdutoService";
import GrupoProdutoService from "@/services/GrupoProdutoService";
import SubGrupoProdutoService from "@/services/SubGrupoProdutoService";
import LinhaProdutoService from "@/services/LinhaProdutoService";
import CategoriaService from "@/services/CategoriaService";
import RamoService from "@/services/RamoService";
import VendasClienteService from "@/services/VendasClienteService";
import ProdutoFamiliaService from "@/services/vendas/produto/ProdutoFamiliaService";
import UnidadeMedidaService from "@/services/UnidadeMedidaService";
// Validations
import ProdutoValidation from "@/services/validations/vendas/produto/ProdutoValidation";

// Modais
import GrupoProdutoModal from "@/components/vendas/produto/modal/GrupoProdutoModal";
import SubGrupoProdutoModal from "@/components/vendas/produto/modal/SubGrupoProdutoModal";
import LinhaProdutoModal from "@/components/vendas/produto/modal/LinhaProdutoModal";
import CategoriaModal from "@/components/vendas/produto/modal/CategoriaModal";
import RamoModal from "@/components/vendas/produto/modal/RamoModal";
import ProdutoFamiliaModal from "@/components/vendas/produto/modal/ProdutoFamiliaModal";
import UnidadeMedidaCadastroModal from "@/components/vendas/produto/modal/dados-cadastrais/unidade-medida/UnidadeMedidaCadastroModal";
import DependenciasModal from "@/components/vendas/produto/modal/DependenciasModal";

// Componentes
import Message from "@/models/Message";

export default {
    components: {
        GrupoProdutoModal,
        SubGrupoProdutoModal,
        LinhaProdutoModal,
        CategoriaModal,
        RamoModal,
        ProdutoFamiliaModal,
        UnidadeMedidaCadastroModal,
        DependenciasModal
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
        telaEmpresa: {
            type: String,
            default: "",
        },
        abrev: {
            type: String,
            default: "ven",
        },
    },
    data() {
        return {
            produtoIntegracao: this.$store.state.user.tabelasERPWebServer.includes("PRODUTO"),
            grupoIntegracao: this.$store.state.user.tabelasERPWebServer.includes("GRUPOPRODUTO"),
            subGrupoIntegracao: this.$store.state.user.tabelasERPWebServer.includes("SUBGRUPOPRODUTO"),
            linhaIntegracao: this.$store.state.user.tabelasERPWebServer.includes("LINHAPRODUTO"),
            categoriaIntegracao: this.$store.state.user.tabelasERPWebServer.includes("CATEGORIA"),
            ramoIntegracao: this.$store.state.user.tabelasERPWebServer.includes("RAMO"),
            clienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes("CLIENTE"),
            familiaIntegracao: this.$store.state.user.tabelasERPWebServer.includes("PROD_FAMILIA"),
            unidadeMedidaIntegracao: this.$store.state.user.tabelasERPWebServer.includes("UNIDADEMEDIDA"),
            msgs: [],
            idproduto: 0,
            produto: {
                idproduto: null,
                idprodutoerp: null,
                descricao: null,
                oculta: null,

                idunidademedida: null,
                unidademedida: {},

                idgrupoproduto: null,
                grupo: {},

                idsubgrupoproduto: null,
                subgrupo: {},

                idlinhaproduto: null,
                linha: {},

                idcategoria: null,
                categoria: {},

                idramo: null,
                ramo: {},

                idfamilia: null,
                produtoFamilia: {},

                idcliente: null,
                cliente: {},

                undmedida: null,
                embalagem: null,
                marca: null,
                codbarras: null,
                undcaixa: null,
                prazoMedioCompra: null,
                ncm: null,
                cst: null,
                cest: null,
                ipi: 0,
                porctroca: 100,
                espessura: 0,
                comprimento: 0,
                largura: 0,
                peso: 0,
                cubagem: 0,
                observacaogeral: null,
                complemento: null,
                referencia: null,
                idsEmpresas: null,
                codigo_mapa: "",
                codigo_mapa_emite_receita: 0,
            },
            qtdCampos: {
                qtdgrupo: 0,
                qtdsubgrupo: 0,
                qtdlinha: 0,
            },
            service: null,
            serviceGrupoProduto: null,
            serviceSubGrupoProduto: null,
            serviceLinhaProdutoService: null,
            serviceRamo: null,
            serviceCategoria: null,
            serviceCliente: null,
            serviceProdutoFamilia: null,
            serviceUnidadeMedida: null,
            validation: null,
            permissao: {},
            cantEdit: false,
            // para controlar algumas ações até os dados serem carregados na edição
            isLoading: false,
            isSaving: false,
            ocultaProdutoSelect: [
                { id: 0, label: "nao" },
                { id: 1, label: "sim" },
            ],
            grupoSelect: [],
            subGrupoSelect: [],
            linhaSelect: [],
            categoriaSelect: [],
            ramoSelect: [],
            clienteSelect: [],
            familiaSelect: [],
            unidadeMedidaSelect: [],
            grupoOk: false,
            subGrupoOk: false,
            linhaOk: false,
            categoriaOk: false,
            ramoOk: false,
            clienteOk: false,
            familiaOk: false,
            unidadeMedidaOk: false,
            grupoSelected: null,
            subGrupoSelected: null,
            linhaSelected: null,
            categoriaSelected: null,
            ramoSelected: null,
            clienteSelected: null,
            familiaSelected: null,
            unidadeMedidaSelected: null,
            grupoLoading: false,
            subGrupoLoading: false,
            linhaLoading: false,
            categoriaLoading: false,
            ramoLoading: false,
            clienteLoading: false,
            familiaLoading: false,
            unidadeMedidaLoading: false,
            invalidPorcentagem: "",
            buttonPlusIsClicked: false,
            modalSelect: "grupo",
            listadependencias: [],
            flagOk: false,
            isLoaded: false,
            codigo_mapa: "",
            emiteReceitaSelect: [
                { id: 0, label: "nao" },
                { id: 1, label: "sim" },
            ],
            emiteReceitaSelected: { id: 0, label: "nao" },
        };
    },
    watch: {
        produto: {
            deep: true,
            handler: function () {
                if(this.isLoaded){
                    this.flagOk = true;
                }
                if (!this.produtoIntegracao && this.flagOk){
                    this.$emit("isChanged", true);
                }
            },
        },
    },
    created() {
        setTimeout(() => { 
            this.$emit("isChanged", false);
        }, 1000);
        
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "ven-produto-dados-cadastrais-geral"
        );

        !this.permissao.read &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "produto" },
            });

        this.service = new ProdutoService(this.$http, this.$router);
        this.serviceGrupoProduto = new GrupoProdutoService(
            this.$http,
            this.$router
        );
        this.serviceSubGrupoProduto = new SubGrupoProdutoService(
            this.$http,
            this.$router
        );
        this.serviceLinhaProdutoService = new LinhaProdutoService(
            this.$http,
            this.$router
        );
        this.serviceCategoria = new CategoriaService(this.$http, this.$router);
        this.serviceRamo = new RamoService(this.$http, this.$router);
        this.serviceCliente = new VendasClienteService(
            this.$http,
            this.$router
        );
        this.serviceProdutoFamilia = new ProdutoFamiliaService(
            this.$http,
            this.$router
        );
        this.serviceUnidadeMedida = new UnidadeMedidaService(
            this.$http,
            this.$router
        );

        this.validation = new ProdutoValidation(this.msgs);

        if (this.$route.params.id && this.isUpdate) {
            this.produto.idproduto = this.$route.params.id;
            this.cantEdit = !this.permissao.update;
            this.carregarDados();
        } else {
            this.loadCategoria();
            this.produto.oculta = this.ocultaProdutoSelect[0];
            setTimeout(() => {
                this.flagOk = true;
            }, 250)
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + "-geral-" + numberId;
        },
        carregarDados() {
            this.isLoading = true;
            this.service
                .find(this.produto.idproduto)
                .then((r) => {
                    this.produto = r.content;
                    this.produto.oculta =
                        this.ocultaProdutoSelect[this.produto.oculta];

                    this.emiteReceitaSelected = this.getEmiteReceituario();
                    this.codigo_mapa = this.produto.codigo_mapa;
                })
                .catch((e) => {
                    console.error("Erro ao carregar dados gerais.", e);

                    this.msgs.push(
                        new Message("error", "msg-erro-dados-geral", true)
                    );
                })
                .then(() => {
                    this.loadCategoria();
                })
                .finally(() => {
                    this.isLoading = false;
                })
        },
        getEmiteReceituario() {
            return this.emiteReceitaSelect.find((er) => er.id == this.produto.codigo_mapa_emite_receita);
        },
        // Emite ao componente pai se houve alteração em um campo select
        sendIsChanged() {
            if(this.grupoOk&&this.subGrupoOk&&this.linhaOk&&this.categoriaOk
                &&this.ramoOk&&this.clienteOk&&this.familiaOk){
                    this.flagOk = true;
                }
            if (this.flagOk){
                this.$emit("isChanged", true);
            }
        },
        // Atualiza os selects com a informação que vêm do modal
        updateSelects(value) {
            switch (value.origem) {
                case "grupo":
                    this.grupoSelect.push(value.obj);
                    this.grupoSelect.sort(this.sortSelects);
                    this.grupoSelected = value.obj;
                    this.subGrupoSelect = [];
                    this.subGrupoSelected = null;
                    this.linhaSelect = [];
                    this.linhaSelected = null;
                    this.buttonPlusIsClicked = false;
                    break;
                case 'subgrupo':
                    this.subGrupoSelect.push(value.obj);
                    this.subGrupoSelect.sort(this.sortSelects);
                    this.subGrupoSelected = value.obj;
                    this.linhaSelect = [];
                    this.linhaSelected = null;
                    this.buttonPlusIsClicked = false;
                    break;
                case 'linha':
                    this.linhaSelect.push(value.obj);
                    this.linhaSelect.sort(this.sortSelects);
                    this.linhaSelected = value.obj;
                    this.buttonPlusIsClicked = false;
                    break;
                case 'categoria':
                    this.categoriaSelect.push(value.obj);
                    this.categoriaSelect.sort(this.sortSelects);
                    this.categoriaSelected = value.obj;
                    this.buttonPlusIsClicked = false;
                    break;
                case 'ramo':
                    this.ramoSelect.push(value.obj);
                    this.ramoSelect.sort(this.sortSelects);
                    this.ramoSelected = value.obj;
                    this.buttonPlusIsClicked = false;
                    break;
                case 'familia':
                    this.familiaSelect.push(value.obj);
                    this.familiaSelect.sort(this.sortSelects);
                    this.familiaSelected = value.obj;
                    this.buttonPlusIsClicked = false;
                    break;
                case 'unidade-medida-vinculo':
                    this.unidadeMedidaSelect.push(value.obj);
                    this.unidadeMedidaSelect.sort(this.sortSelects);
                    this.unidadeMedidaSelected = value.obj;
                    this.buttonPlusIsClicked = false;
                    this.$parent.$children.forEach((e) => {
                        if(e.$el.className === 'aba-unidade-medida'){
                            e.loadTabUnMedida();
                        }
                    })
                    break;
            }
        },
        loadCategoria(params = ".*") {
            this.categoriaLoading = true;
            this.serviceCategoria
                .findAllCombo(1, params)
                .then((r) => {
                    this.categoriaSelect = r.content.map((e) => {
                        return { id: e.id, label: e.descricao };
                    });
                })
                .catch((e) => {
                    this.categoriaLoading = false;
                    console.error("Erro ao carregar categoria", e);

                    this.msgs.push(
                        new Message("error", "msg-erro-dados-geral", true)
                    );
                })
                .finally(() => {
                    this.categoriaLoading = false;
                    if (this.isUpdate) {
                        let tempCategoria = this.categoriaSelect.filter(
                            (e) => e.id === this.produto.idcategoria
                        );
                        this.categoriaSelected =
                            tempCategoria.length > 0
                                ? tempCategoria[0]
                                : this.categoriaSelect[0];
                    } else if(this.categoriaSelect.length == 1){
                        this.categoriaSelected = this.categoriaSelect[0];
                    }
                    setTimeout(() => {
                        this.categoriaOk = true;
                    }, 250);
                    if(!this.isLoaded) this.loadRamo();
                });
        },
        loadRamo(params = ".*") {
            this.ramoLoading = true;
            this.serviceRamo
                .findAllCombo(100, params)
                .then((r) => {
                    this.ramoSelect = r.content.map((e) => {
                        return { id: e.id, label: e.descricao };
                    });
                })
                .catch((e) => {
                    this.ramoLoading = false;
                    console.error("Erro ao carregar ramo.", e);

                    this.msgs.push(
                        new Message("error", "msg-erro-dados-geral", true)
                    );
                })
                .finally(() => {
                    this.ramoLoading = false;
                    if (this.isUpdate && this.produto.ramo != null) {
                        let tempRamo = this.ramoSelect.filter(
                            (e) => e.id === this.produto.ramo.id
                        );
                        this.ramoSelected =
                            tempRamo.length > 0
                                ? tempRamo[0]
                                : this.ramoSelect[0];
                    } else if(this.ramoSelect.length == 1){
                        this.ramoSelected = this.ramoSelect[0];
                    }
                    setTimeout(() => {
                        this.ramoOk = true;
                    }, 250);
                    if(!this.isLoaded) this.loadCliente();
                });
        },
        loadCliente(params = ".*", isSearch = false) {
            this.clienteLoading = true;
            if (!isSearch) {
                this.clienteSelect.push({
                    id: 0,
                    label: this.$t("todos").toUpperCase(),
                });
            }

            this.serviceCliente
                .findAllCombo(params)
                .then((r) => {
                    r.content.map((e) => {
                        this.clienteSelect.push({ id: e.id, label: e.nome });
                    });
                })
                .catch((e) => {
                    this.clienteLoading = false;
                    console.error("Erro ao carregar cliente.", e);

                    this.msgs.push(
                        new Message("error", "msg-erro-dados-geral", true)
                    );
                })
                .finally(() => {
                    this.clienteLoading = false;
                    if (this.isUpdate && this.produto.cliente != null) {
                        let tempCliente = this.clienteSelect.filter(
                            (e) => e.id === this.produto.cliente.id
                        );
                        this.clienteSelected =
                            tempCliente.length > 0
                                ? tempCliente[0]
                                : this.clienteSelect[0];
                    } else if(this.clienteSelect.length == 1){
                        this.clienteSelected = this.clienteSelect[0];
                    }
                    setTimeout(() => {
                        this.clienteOk = true;
                    }, 250);
                    if(!this.isLoaded) this.loadUnidadeMedida();
                });
        },
        loadUnidadeMedida(params = ".*") {
            if(this.produto.idproduto){
                this.unidadeMedidaLoading = true;
                this.serviceUnidadeMedida
                    .findallcomboassproduto(this.produto.idproduto, 100, 0, params)
                    .then((r) => {
                        this.unidadeMedidaSelect = r.content.map((e) => {
                            return { id: e.id, label: e.id+' - '+e.descricao };
                        });
                        this.unidadeMedidaSelect.unshift({ id: 0, label: "0 - "+"SEM UNIDADE DE MEDIDA" })
                    })
                    .catch((e) => {
                        this.unidadeMedidaLoading = false;
                        console.error("Erro ao carregar unidade de medida.", e);

                        this.msgs.push(
                            new Message("error", "msg-erro-dados-geral", true)
                        );
                    })
                    .finally(() => {
                        this.unidadeMedidaLoading = false;
                        if (this.isUpdate && this.produto.idunidademedida != null) {
                            let tempUnidadeMedida = this.unidadeMedidaSelect.filter(
                                (e) => e.id === this.produto.idunidademedida
                            );
                            this.unidadeMedidaSelected =
                                tempUnidadeMedida.length > 0
                                    ? tempUnidadeMedida[0]
                                    : this.unidadeMedidaSelect[0];
                        } else if(this.unidadeMedidaSelect.length == 1){
                            this.unidadeMedidaSelected = this.unidadeMedidaSelect[0];
                        }
                        setTimeout(() => {
                            this.unidadeMedidaOk = true;
                        }, 250);
                        if(!this.isLoaded) this.loadFamilia();
                    });
            } else {
                if(!this.isLoaded) this.loadFamilia();
            }
        },
        loadFamilia(params = ".*") {
            this.familiaLoading = true;
            // no caso é passado 0, por que na sql esta situacao <> :SITUACAO, nesse caso se quiser buscar todas passar 2.
            this.serviceProdutoFamilia
                .findAllCombo(100, 0, params)
                .then((r) => {
                    this.familiaSelect = r.content.map((e) => {
                        return { id: e.id, label: e.descricao };
                    });
                })
                .catch((e) => {
                    this.familiaLoading = false;
                    console.error("Erro ao carregar família.", e);

                    this.msgs.push(
                        new Message("error", "msg-erro-dados-geral", true)
                    );
                })
                .finally(() => {
                    this.familiaLoading = false;
                    if (this.isUpdate && this.produto.produtoFamilia != null) {
                        let tempFamilia = this.familiaSelect.filter(
                            (e) => e.id === this.produto.produtoFamilia.id
                        );
                        this.familiaSelected =
                            tempFamilia.length > 0
                                ? tempFamilia[0]
                                : this.familiaSelect[0];
                    } else if(this.familiaSelect.length == 1){
                        this.familiaSelected = this.familiaSelect[0];
                    }
                    setTimeout(() => {
                        this.familiaOk = true;
                    }, 250);
                    if(!this.isLoaded) this.loadGrupo();
                });
        },
        loadGrupo(params = ".*", isSearch = false) {
            this.grupoLoading = true;
            this.serviceGrupoProduto
                .findAllComboWithEmpresa(!this.produto.idsEmpresas && 0, params)
                .then((r) => {
                    this.grupoSelect = r.content.map((e) => {
                        return { id: e.id, label: e.descricao };
                    });
                })
                .catch((e) => {
                    this.grupoLoading = false;
                    console.error("Erro ao carregar dados gerais.", e);

                    this.msgs.push(
                        new Message("error", "msg-erro-dados-geral", true)
                    );
                })
                .finally(() => {
                    this.grupoLoading = false;
                    if (this.isUpdate && this.produto.grupoproduto != null) {
                        let tempGrupo = this.grupoSelect.filter(
                            (e) => e.id === this.produto.grupoproduto.id
                        );
                        this.grupoSelected =
                            tempGrupo.length > 0
                                ? tempGrupo[0]
                                : this.grupoSelect[0];
                    } else if(this.grupoSelect.length == 1){
                        this.grupoSelected = this.grupoSelect[0];
                    }
                    
                    setTimeout(() => {
                        this.grupoOk = true;
                        this.verificaDependencias()
                    }, 250)
                    if (!isSearch) {
                        this.loadSubGrupo();
                    }

                })
        },
        loadSubGrupo(params = ".*", isSearch = false) {
            if (!isSearch) {
                this.subGrupoSelected = null;
                this.linhaSelected = null;
            }

            if (this.grupoSelected) {
                this.subGrupoLoading = true;
                this.serviceSubGrupoProduto
                    .findAllCombo(
                        0,
                        100,
                        { order: "asc", column: "DESCRICAO" },
                        this.grupoSelected.id,
                        1,
                        params
                    )
                    .then((r) => {
                        this.subGrupoSelect = r.content.map((e) => {
                            return { id: e.id, label: e.descricao };
                        });
                    })
                    .catch((e) => {
                        this.subGrupoLoading = false;
                        console.error("Erro ao carregar dados gerais.", e);

                        this.msgs.push(
                            new Message("error", "msg-erro-dados-geral", true)
                        );
                    })
                    .finally(() => {
                        this.subGrupoLoading = false;
                        if (this.isUpdate) {
                            let tempSubGrupo;
                            if (this.produto.subgrupoproduto) {
                                tempSubGrupo = this.subGrupoSelect.filter(
                                    (e) => e.id === this.produto.subgrupoproduto.id
                                );
                            } else {
                                tempSubGrupo = [];
                            }

                            this.subGrupoSelected =
                                tempSubGrupo.length > 0
                                    ? tempSubGrupo[0]
                                    : this.subGrupoSelect[0];
                        } else if(this.subGrupoSelect.length == 1){
                            this.subGrupoSelected = this.subGrupoSelect[0];
                        }
                        setTimeout(() => {
                            this.subGrupoOk = true;
                        }, 250)
                        if (!isSearch) {
                            this.loadLinha();
                        }
                    });
            } else {
                setTimeout(() => {
                    this.subGrupoOk = true;
                }, 250)
            }
        },
        loadLinha(params = ".*", isSearch = false) {
            if (!isSearch) {
                this.linhaSelected = null;
            }

            if (this.subGrupoSelected) {
                this.linhaLoading = true;
                this.serviceLinhaProdutoService
                    .findAll(
                        "DESCRICAO",
                        "asc",
                        0,
                        100,
                        this.subGrupoSelected.id,
                        1,
                        params
                    )
                    .then((r) => {
                        this.linhaSelect = r.content.map((e) => {
                            return { id: e.id, label: e.descricao };
                        });
                    })
                    .catch((e) => {
                        this.linhaLoading = false;
                        console.error("Erro ao carregar dados gerais.", e);

                        this.msgs.push(
                            new Message("error", "msg-erro-dados-geral", true)
                        );
                    })
                    .finally(() => {
                        this.linhaLoading = false;
                        if (this.isUpdate && this.produto.linhaproduto != null) {
                            let tempLinhaGrupo = this.linhaSelect.filter(
                                (e) => e.id === this.produto.linhaproduto.id
                            );
                            this.linhaSelected =
                                tempLinhaGrupo.length > 0
                                    ? tempLinhaGrupo[0]
                                    : this.linhaSelect[0];
                        } else if(this.linhaSelect.length == 1){
                            this.linhaSelected = this.linhaSelect[0];
                        }
                        setTimeout(() => {
                            this.linhaOk = true;
                        }, 250);
                    });
                } else {
                setTimeout(() => {
                    this.linhaOk = true;
                }, 250)
                this.linhaSelect = [];
                this.linhaSelected = null;
            }
        },
        sortSelects(a, b) {
            let fa = a.label.toLocaleUpperCase(),
                fb = b.label.toLocaleUpperCase();

            if (fa < fb) {
                return -1;
            }
            if (fa > fb) {
                return 1;
            }
            return 0;
        },
        /**
         * Se for p significa que a porcentagem está incorreta,
         * se for v significa que o valor não foi preenchido.
         */
        validatePorcentagemInner() {
            if (this.isNull(this.produto.porctroca)) {
                this.invalidPorcentagem = "v";
                return true;
            }else if (!this.validatePorcentagem(this.produto.porctroca)) {
                this.invalidPorcentagem = "p";
                return true;
            }

            this.invalidPorcentagem = "";
            return false;
        },
        showMessage() {
            if (this.invalidPorcentagem === "p") {
                return "msg-erro-config-porctroca-maior-zero";
            // } else if (this.invalidPorcentagem === "v") {
            //     return "msg-campo-obrigatorio";
            } else {
                return "";
            }
        },
        constructJson(key, value) {
            let obj = {};
            obj[key] = value;
            return obj;
        },
        save() {
            this.isLoading = true;
            // busco as informações do produto em uma variável temporária para preencher os valores dos selects
            let tempProduto = Object.assign({}, this.produto);

            // preenche com as informações dos selects.
            
            tempProduto.idgrupoproduto = 
                this.grupoSelected != null ? this.grupoSelected.id : 0;
            
            tempProduto.idsubgrupoproduto = 
                this.subGrupoSelected != null ? this.subGrupoSelected.id : 0;
            
            tempProduto.idlinhaproduto =
                this.linhaSelected != null ? this.linhaSelected.id : 0;
            
            tempProduto.idcategoria =
                this.categoriaSelected != null ? this.categoriaSelected.id : 0;
            
            tempProduto.idunidademedida =
                this.unidadeMedidaSelected != null ? this.unidadeMedidaSelected.id : 0;
            
            tempProduto.idramo =
                this.ramoSelected != null ? this.ramoSelected.id : 0;
            
            tempProduto.idcliente =
                this.clienteSelected != null ? this.clienteSelected.id : 0;
            
            tempProduto.idfamilia =
            this.familiaSelected != null ? this.familiaSelected.id : 0;

            if(tempProduto.codbarras == null) tempProduto.codbarras = '';
            if(tempProduto.undcaixa == null) tempProduto.undcaixa = '';
            if(tempProduto.prazoMedioCompra == null) tempProduto.prazoMedioCompra = '';
            if(tempProduto.undmedida == null) tempProduto.undmedida = '';
            if(tempProduto.embalagem == null) tempProduto.embalagem = '';
            if(tempProduto.marca == null) tempProduto.marca = '';
            if(tempProduto.referencia == null) tempProduto.referencia = '';
            if(tempProduto.complemento == null) tempProduto.complemento = '';
            if(tempProduto.observacaogeral == null) tempProduto.observacaogeral = '';
            if(tempProduto.ncm == null) tempProduto.ncm = '';
            if(tempProduto.cst == null) tempProduto.cst = '';
            if(tempProduto.cest == null) tempProduto.cest = '';
            if(tempProduto.ipi == null) tempProduto.ipi = 0;
            if(tempProduto.espessura == null) tempProduto.espessura = 0;
            if(tempProduto.comprimento == null) tempProduto.comprimento = 0;
            if(tempProduto.peso == null) tempProduto.peso = 0;
            if(tempProduto.porctroca == null) tempProduto.peso = 100;
            if(tempProduto.cubagem == null) tempProduto.cubagem = 0;

            tempProduto.oculta = tempProduto.oculta.id;

            tempProduto.codigo_mapa_emite_receita = this.emiteReceitaSelected.id;

            if (this.validation.validate(tempProduto, this.$refs, this.isUpdate)) {
                this.isSaving = true;
                tempProduto = this.mapTosave(tempProduto);

                tempProduto.codigo_mapa = this.codigo_mapa;

                this.service
                    .save(tempProduto)
                    .then((value) => {
                        if (value.message == null) {
                            let msg =
                                this.produto.idproduto != null
                                    ? "msg-produto-editado"
                                    : "msg-produto-salvo";
                            this.msgs.push(new Message("success", msg, true));
                            this.$emit("isChanged", false);
                            this.refreshPage(value.content.id);
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(
                                    new Message("alert", value.message, true)
                                );
                            } else {
                                this.msgs.push(
                                    new Message(
                                        "error",
                                        "msg-problema-realizar-acao",
                                        true
                                    )
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (e.body.status == 500) {
                            this.msgs.push(
                                new Message("alert", e.body.message, true)
                            );
                        }else if (e.body.status == '403') {
                            this.msgs.push(
                                new Message("alert", 'msg-acesso-nao-permitido', true)
                            );
                        } else {
                            console.error("Erro ao salvar: " + e);
                            this.msgs.push(
                                new Message("error", "msg-erro-salvar", true)
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.isLoading = false;
            }
        },
        //ADICIONAR OS CAMPOS OBRIGATORIOS DE SELECT AQUI PARA EXIBIR NO MODAL DE DEPENDENCIA
        verificaDependencias(){
            const itensCadastrar = []

            if(!this.cantEdit && !this.produtoIntegracao && !this.$route.params.id){
                if(!this.categoriaSelect || this.categoriaSelect.length == 0){
                    itensCadastrar.push('categoria');
                }
                if(!this.ramoSelect || this.ramoSelect.length == 0){
                    itensCadastrar.push('ramo'); 
                }
                if(!this.clienteSelect || this.clienteSelect.length == 0){
                    itensCadastrar.push('cliente'); 
                }
                if(!this.familiaSelect || this.familiaSelect.length == 0){
                    itensCadastrar.push('familia'); 
                }

                this.service
                    .findQtdGrupoSubLinha()
                    .then((r) => {
                        this.qtdCampos = r.content
                    })
                    .catch((e) => {
                        this.subGrupoLoading = false;
                        console.error("Erro ao carregar dados gerais.", e);

                        this.msgs.push(
                            new Message("error", "msg-erro-dados-geral", true)
                        );
                    })
                    .finally(() => {
                        if(this.qtdCampos.qtdsubgrupo == 0){
                            itensCadastrar.push('subgrupo'); 
                        }
                        if(this.qtdCampos.qtdlinha == 0){
                            itensCadastrar.push('linha'); 
                        }
                        if(this.qtdCampos.qtdgrupo == 0){
                            itensCadastrar.push('grupo'); 
                        }

                        if(itensCadastrar.length != 0){
                            this.listadependencias = itensCadastrar;
                            this.showModal('dependencias');
                        }
                    });
            }
            this.isLoaded = true;
        },
        refreshPage(id) {
            let tempTela = "ven-produto-dados-cadastrais-edit";
            let tempQuery = null;
            let descricao = null;
            if (this.$route.query.tela == 'ven-pacote-kit'){
                tempQuery = { tela: 'ven-pacote-kit', id: this.$route.query['id'] }
            } else if (this.$route.query.tela == `${this.abrev}-cultura-edit`) {
                tempTela = `${this.abrev}-cultura-edit`;
                tempQuery = { abaSelecionada: 'produto' };
                descricao = this.$route.query.descricao;
            } else if (this.$route.query.tela == 'empresa-produto') {
                tempTela = 'ven-empresa-dados-cadastrais-edit';
                tempQuery = { 
                    dadoscadastrais: this.$route.query.dadoscadastrais, 
                    politicacomercial: this.$route.query.politicacomercial,
                };
            } else if (this.$route.query.tela == 'motivo-atendimento') {
                tempTela = 'ven-motivo-atendimento-edit';
                tempQuery = { abaSelecionada: 'produtosPesquisaMercado' };
            }
            setTimeout(() => {
                this.$router.push({
                    name: tempTela,
                    params: { id: this.$route.query['id'], descricao: descricao },
                    query: tempQuery,
                });
            }, 1000);
        },
        showModal(modal) {
            switch (modal) {
                case "grupo":
                    this.modalSelect = "grupo";
                    this.buttonPlusIsClicked = true;
                    break;
                case "subgrupo":
                    this.modalSelect = "subgrupo";
                    this.buttonPlusIsClicked = true;
                    break;
                case "linha":
                    this.modalSelect = "linha";
                    this.buttonPlusIsClicked = true;
                    break;
                case "categoria":
                    this.modalSelect = "categoria";
                    this.buttonPlusIsClicked = true;
                    break;
                case "ramo":
                    this.modalSelect = "ramo";
                    this.buttonPlusIsClicked = true;
                    break;
                case "cliente":
                    this.modalSelect = "cliente";
                    this.buttonPlusIsClicked = true;
                    break;
                case "familia":
                    this.modalSelect = "familia";
                    this.buttonPlusIsClicked = true;
                    break;
                case "unidade-medida":
                    this.modalSelect = "unidade-medida";
                    this.buttonPlusIsClicked = true;
                    break;
                case "unidade-medida-vinculo":
                    this.modalSelect = "unidade-medida-vinculo";
                    this.buttonPlusIsClicked = true;
                    break;    
                // case "dependencias":
                //     this.modalSelect = "dependencias";
                //     this.buttonPlusIsClicked = true;
                //     break;        
            }
        },
        closeModal() {
            this.modalSelect = "";
            this.buttonPlusIsClicked = false;
        },
        verifyPermissions(integracao) {
            return (
                !integracao && !this.isUpdate && this.permissao.create) 
                || (!integracao && this.isUpdate && this.permissao.update
            );
        },
        redirectCadastroCliente() {
            let tempTela;
            let id = this.$route.params.id;
            if (!id) {
                tempTela = 'ven-produto-dados-cadastrais-new';
            } else {
                tempTela = 'ven-produto-dados-cadastrais-edit';
            }

            this.$router.push({ 
                name: 'ven-cliente-new', 
                query: { 
                    tela: tempTela, 
                    'id': id ? id : 0,
                    dadoscadastrais: 0,
                    politicacomercial: this.$route.query.politicacomercial 
                        ? this.$route.query.politicacomercial
                        : null,
                    analisecomercial: this.$route.query.analisecomercial 
                        ? this.$route.query.analisecomercial
                        : null  
                } 
            });
        }
    },
};
</script>
